import { JobSearch } from '@borg/types';

class HistoryService {
  getSearchHistory = () => serviceHttpGetFactory<JobSearch[]>(`/jobs/search-history`);
}

export const historyService = new HistoryService();
